module.exports = __webpack_public_path__ + "static/media/11.313d90d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/11.wav
// module id = N6lK
// module chunks = 0